var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c(
        "Header",
        {
          style: {
            background: "#fff",
            boxShadow: "0 2px 3px 2px rgba(0,0,0,.1)",
            padding: 0,
            height: "60px",
            lineHeight: "60px"
          }
        },
        [
          _c(
            "Menu",
            {
              ref: "header_menu",
              staticClass: "headerSetting",
              attrs: {
                mode: "horizontal",
                theme: "dark",
                "active-name": _vm.headerActive
              },
              on: { "on-select": _vm.headerChangeMenu }
            },
            [
              _c("div", { staticClass: "layout-logo" }, [
                _c("img", {
                  staticClass: "logoSetting",
                  attrs: { src: _vm.logoUrl, alt: "月子会所" }
                })
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "layout-nav" },
                [
                  _c(
                    "MenuItem",
                    { attrs: { name: "erp" } },
                    [
                      _c("Icon", {
                        attrs: { type: "md-arrow-dropleft-circle" }
                      }),
                      _vm._v("\n          返回ERP\n        ")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.menuList, function(item) {
                    return _c(
                      "MenuItem",
                      { key: item.id, attrs: { name: item.show_name } },
                      [
                        _c("Icon", { attrs: { type: item.icon } }),
                        _vm._v(
                          "\n          " + _vm._s(item.show_name) + "\n        "
                        )
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "userName" },
                    [
                      _c("Icon", {
                        attrs: { type: "ios-contact", size: "16" }
                      }),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.agent_info.store_name) +
                          " | " +
                          _vm._s(_vm.agent_info.position_name) +
                          " |\n          " +
                          _vm._s(_vm.agent_info.user_name) +
                          "\n        "
                      )
                    ],
                    1
                  )
                ],
                2
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Layout",
        { style: { marginLeft: _vm.SiderMarginLeft, position: "relative" } },
        [
          _c(
            "Sider",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.MenuShow,
                  expression: "MenuShow"
                }
              ],
              staticClass: "SiderChange",
              attrs: { width: _vm.SiderWidth }
            },
            [
              _c(
                "Menu",
                {
                  ref: "side_menu",
                  attrs: {
                    "active-name": _vm.active,
                    "open-names": _vm.openNames,
                    theme: "dark",
                    width: "auto",
                    accordion: ""
                  },
                  on: { "on-select": _vm.leftMenuchange }
                },
                _vm._l(_vm.leftMenuList, function(item) {
                  return _c(
                    "Submenu",
                    { key: item.id, attrs: { name: item.id + "" } },
                    [
                      _c(
                        "template",
                        { slot: "title" },
                        [
                          _c("Icon", { attrs: { type: item.icon } }),
                          _vm._v(
                            "\n            " +
                              _vm._s(item.show_name) +
                              "\n          "
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(item.child_permissions, function(child) {
                        return _c(
                          "MenuItem",
                          { key: child.id, attrs: { name: child.id + "" } },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(child.show_name) +
                                "\n          "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "backBtn", on: { click: _vm.bindtagBack } },
            [
              _c("Icon", {
                attrs: {
                  type: _vm.bintagBackIcon,
                  size: "16",
                  color: "#ffffff"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "Content",
            { style: { padding: "0 16px 16px" } },
            [
              _c(
                "Breadcrumb",
                { style: { margin: "16px 0" } },
                _vm._l(_vm.set_VBreadcrumb_arr, function(item, index) {
                  return _c("BreadcrumbItem", { key: index }, [
                    _vm._v(_vm._s(item))
                  ])
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "Card",
                { staticClass: "componentsContent" },
                [_c("router-view")],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 